import { render, staticRenderFns } from "./2faSetup.vue?vue&type=template&id=7b2f84de&scoped=true&"
import script from "./2faSetup.vue?vue&type=script&lang=js&"
export * from "./2faSetup.vue?vue&type=script&lang=js&"
import style0 from "./2faSetup.vue?vue&type=style&index=0&id=7b2f84de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f84de",
  null
  
)

export default component.exports